import React, { useCallback, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  Grid,
  Box,
  TextFieldProps,
  TextField,
  FormControl,
  Select,
  MenuItem,
  SelectChangeEvent,
  Stack,
  Typography,
  Button,
  Autocomplete,
  CircularProgress,
} from "@mui/material";
import {
  GridActionsCellItem,
  GridRowId,
  GridFilterOperator,
  GridFilterItem,
  GridFilterInputValueProps,
  getGridDateOperators,
  getGridStringOperators,
  GridRenderCellParams,
  GridValidRowModel,
  GridRowSelectionModel,
} from "@mui/x-data-grid-pro";

import Item from "../../Template/Item";
import WithPermission from "../../components/WithPermission";
import TableSkeleton from "../../components/TableSkeleton";
import Dilogbox from "../../components/Dilogbox";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirm } from "react-confirm-box";
import { Link } from "react-router-dom";

import ReceiptIcon from "@mui/icons-material/Receipt";
import DescriptionIcon from "@mui/icons-material/Description";

import {
  loadTimesheet,
  trashTimesheet,
  getTimesheetProfile,
  bulkTimesheetDelete,
  updatePayrollChange,
  UpdatePayrollFormType,
  loadInvoices,
  loadPayrolls,
  updateInvoiceChange,
  updateInvoiceFormType,
  createPayroll,
  loadRegions,
  updateRegionChange,
} from "../../redux/actions/timesheet.actions";

//import { GridFilterOperator } from '@mui/x-data-grid';

import SyncIcon from "@mui/icons-material/Sync";
import GridCellExpand from "../../components/GridCelExpand";
import { TimesheetForm } from "./timesheet-form";
import { ClockoutForm } from "./clockout-form";
import { FacilityForm } from "./facility-form";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { TimesheetEditForm } from "./timesheet-edit-form";
import { TimesheetEditClockInForm } from "./timesheet-edit-clockin-form";
import HourglassDisabledIcon from "@mui/icons-material/HourglassDisabled";
import { storeStateType, useAppDispatch } from "../../redux/store";

import CustomDataGridPro from "../../components/CustomDataGridPro/CustomDataGridPro";
import moment from "moment";
import { ITimesheet } from "../../redux/reducers/timesheet.reducer";

import AddIcon from "@mui/icons-material/Add";
import { TimesheetInvoice } from "./InvoiceModal";
import { TIMESHEET_SAVE_REQUEST } from "../../redux/types/timesheet.types";

// type dataType = {
//   id: string;
//   employee: {
//     fullname: string;
//     id: number;
//     guid: string;
//     role: string;
//   };
//   facility_location: {
//     facility_name: string;
//     facility_tree: any;
//   };
//   shift_start_date: string;
//   shift_start_time: string;
//   shift_end_date: string;
//   shift_end_time: string;
//   break_time: string;
//   shift: string;
//   authorized_wardnamnager: string;
//   total_hours: string;
//   shift_comments: string;
//   holiday_name: string;
//   is_holiday: boolean;
//   remarks: string;
// };

type filterColumnType = {
  col: string;
  opt: string;
  value: string;
};
type MultiFiltersType = {
  page: number;
  filters?: filterColumnType[];
  logicalOperator?: "and" | "or";
  q?: string;
  size: number;
  fortnight?: 0 | 1;
};

const customOptions = {
  render: (
    message: string,
    onConfirm: React.MouseEventHandler<HTMLButtonElement>,
    onCancel: React.MouseEventHandler<HTMLButtonElement>
  ) => {
    return (
      <Dilogbox
        isDialogOpened={true}
        handleConfirmDialog={onConfirm}
        handleCloseDialog={onCancel}
        message={message}
      />
    );
  },
};

function renderCellExpand(params: GridRenderCellParams<GridValidRowModel>) {
  return (
    <GridCellExpand
      value={params.value || ""}
      width={params.colDef.computedWidth}
    />
  );
}

// const fieldTypeList = [
//   { key: 1, value: "Super Admin" },
//   { key: 2, value: "Staff" },
//   { key: 3, value: "Registered User" },
// ];

export interface Filters {
  page: number;
  col: string;
  opt: string;
  value: string;
  q: string;
  size: number;
}

export default function Timesheet() {
  const dispatch = useAppDispatch();
  const [page, setPage] = React.useState(0);
  const [selectedRows, setSelectedRows] = useState<string[]>([]);

  const {
    timesheets,
    timesheet,
    total,
    loading,
    current,
    invoices,
    payrolls,
    regions,
  } = useSelector((state: storeStateType) => state.employeetimesheet);
  const [isOpenInvoice, setOpenInvoice] = React.useState<boolean>(false);
  const [isOpen, setIsOpen] = React.useState<boolean>(false);
  const [isOpenClockOut, setIsOpenClockOut] = React.useState<boolean>(false);
  const [isOpenEdit, setIsOpenEdit] = React.useState<boolean>(false);
  const [isOpenEditClockin, setIsOpenEditClockin] =
    React.useState<boolean>(false);

  const [isOpenFacility, setIsOpenFacility] = React.useState<boolean>(false);
  const [editRequest, setEditRequest] = React.useState<boolean>(false);
  const [handelaction, setHandelaction] = React.useState<string>("");
  const [csvData] = React.useState([]);
  const csvDownloadBtn = React.useRef<any>();
  const [, setSelectionModel] = React.useState<GridRowSelectionModel>([]);
  const [pageSize, setPageSize] = React.useState<number>(10);
  const [filterData, setFilterrData] = React.useState<MultiFiltersType>({
    page: 1,
    size: 10,
    fortnight: 0,
  });
  const [isFortnightRequest, setIsFortnightRequest] = useState<boolean>(false);
  const [stateFlag, setStateFlag] = React.useState<boolean>(false);
  const [paginationEvent] = React.useState<boolean>(false);
  const [isPayrollCreateClick, setIsPayrollCreateClick] =
    React.useState<boolean>(false);
  const globalSettings = useSelector(
    (state: storeStateType) => state.sitesetting.settings
  );
  const [userRoleList, setUserRoleList] = React.useState<
    { key: string; value: string }[]
  >([]);
  const [invoicesList, setInvoicesList] = React.useState<
    { id: string; label: string }[]
  >([]);
  const [payrollList, setPayrollList] = React.useState<
    { id: string; label: string }[]
  >([]);
  const [regionList, setRegionList] = React.useState<
    { id: string; label: string }[]
  >([]);

  useEffect(() => {
    if (globalSettings) {
      globalSettings.forEach((item: any) => {
        if (item["config_name"] === "site") {
          const configvalue = JSON.parse(item["config_value"]);
          if (configvalue) {
            //const fieldTypeList = [{ 'key': 1, 'value': 'Super Admin' }, { 'key': 2, 'value': 'Staff' }, { 'key': 3, 'value': 'Registered User' }]
            setUserRoleList(
              configvalue["employee_role"]?.split(/\r?\n/)?.map((role: any) => {
                return { key: role, value: role };
              })
            );
          }
        }
      });
    }
  }, [globalSettings]);

  useEffect(() => {
    if (!loading) setIsPayrollCreateClick(false);
  }, [loading]);

  useEffect(() => {
    let invoiceListItems: { id: string; label: string }[] = [];
    invoiceListItems =
      invoices?.map((invoiceObj) => {
        return { id: invoiceObj.ItemID, label: invoiceObj.Code };
      }) ?? [];
    setInvoicesList(invoiceListItems);
  }, [invoices]);

  useEffect(() => {
    let payrollListItem: { id: string; label: string }[] = [];
    payrollListItem =
      payrolls?.map((payrollObj) => {
        return { id: payrollObj.EarningsRateID, label: payrollObj.Name };
      }) ?? [];
    setPayrollList(payrollListItem);
  }, [payrolls]);

  useEffect(() => {
    let regionOption: { id: string; label: string }[] = [];
    regionOption =
      regions?.map((region) => {
        return { id: region.TrackingOptionID, label: region.Name };
      }) ?? [];
    setRegionList(regionOption);
  }, [regions]);

  useEffect(() => {
    if (timesheet && editRequest) {
      setIsOpen(true);
      setEditRequest(false);
    }
  }, [timesheet, editRequest]);

  useEffect(() => {
    //if (page > 0) {
    if (paginationEvent) {
      //setFilterrData(prev => ({ ...prev, page: page }));
      setFilterrData((prev) => ({ ...prev, page: page + 1 }));
      setStateFlag((preState) => !preState);
    }
  }, [page, paginationEvent]);

  useEffect(() => {
    setFilterrData((prev) => ({
      ...prev,
      fortnight: isFortnightRequest ? 1 : 0,
    }));
  }, [isFortnightRequest]);

  function InputNumberInterval(props: GridFilterInputValueProps) {
    const { item, applyValue, focusElementRef = null } = props;

    const filterTimeout = React.useRef<number>();
    const [filterValueState, setFilterValueState] = React.useState<
      [string, string]
    >(item.value ?? "");
    const [applying, setIsApplying] = React.useState<boolean>(false);

    React.useEffect(() => {
      return () => {
        clearTimeout(filterTimeout.current);
      };
    }, []);

    React.useEffect(() => {
      const itemValue = item.value ?? [undefined, undefined];
      setFilterValueState(itemValue);
    }, [item.value]);

    const updateFilterValue = (lowerBound: string, upperBound: string) => {
      clearTimeout(filterTimeout.current);
      setFilterValueState([lowerBound, upperBound]);

      setIsApplying(true);
      filterTimeout.current = setTimeout(() => {
        setIsApplying(false);
        applyValue({ ...item, value: [lowerBound, upperBound] });
      }, 500) as unknown as number;
    };

    const handleUpperFilterChange: TextFieldProps["onChange"] = (event) => {
      const newUpperBound = event.target.value;
      updateFilterValue(filterValueState[0], newUpperBound);
    };
    const handleLowerFilterChange: TextFieldProps["onChange"] = (event) => {
      const newLowerBound = event.target.value;

      updateFilterValue(newLowerBound, filterValueState[1]);
    };

    return (
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "end",
          height: 48,
          pl: "20px",
        }}
      >
        <TextField
          name="lower-bound-input"
          placeholder="From"
          label="From"
          variant="standard"
          value={filterValueState[0]}
          onChange={handleLowerFilterChange}
          type="date"
          inputRef={focusElementRef}
          sx={{ mr: 2 }}
          InputLabelProps={{
            shrink: true,
          }}
        />
        <TextField
          name="upper-bound-input"
          placeholder="To"
          label="To"
          variant="standard"
          value={filterValueState[1]}
          onChange={handleUpperFilterChange}
          type="date"
          InputProps={applying ? { endAdornment: <SyncIcon /> } : {}}
          InputLabelProps={{
            shrink: true,
          }}
        />
      </Box>
    );
  }

  function InputRolesList(props: GridFilterInputValueProps) {
    const { item, applyValue } = props;

    const filterTimeout = React.useRef<number>();
    const [filterValueState, setFilterValueState] = React.useState<[string]>(
      item.value ?? ""
    );
    const [, setIsApplying] = React.useState<boolean>(false);

    const [, setRole] = React.useState<string>("");

    React.useEffect(() => {
      return () => {
        clearTimeout(filterTimeout.current);
      };
    }, []);

    React.useEffect(() => {
      const itemValue = item.value ?? [undefined];
      setFilterValueState(itemValue);
    }, [item.value]);

    const updateRoleFilterValue = (lowerBound: string) => {
      clearTimeout(filterTimeout.current);
      setFilterValueState([lowerBound]);

      setIsApplying(true);
      filterTimeout.current = setTimeout(() => {
        setIsApplying(false);
        applyValue({ ...item, value: [lowerBound] });
      }, 500) as unknown as number;
    };

    const handelRoleChage = (event: SelectChangeEvent) => {
      //setAge(event.target.value as string);
      updateRoleFilterValue(event.target.value as string);
      setRole(event.target.value as string);
    };

    return (
      <Box
        sx={{
          display: "inline-flex",
          flexDirection: "row",
          alignItems: "end",
          height: 48,
          pl: "20px",
        }}
      >
        <FormControl
          fullWidth
          className="custom_select"
          variant="standard"
          sx={{ mt: 2 }}
        >
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Role"
            value={filterValueState[0]}
            onChange={handelRoleChage}
          >
            {userRoleList &&
              userRoleList.map((c: any) => (
                <MenuItem key={`c-${c.key}`} value={c.key}>
                  {c.value}
                </MenuItem>
              ))}
          </Select>
        </FormControl>
      </Box>
    );
  }

  // Only keep '>' and '<' default operators

  const dateFilerOperators: GridFilterOperator[] = [
    ...getGridDateOperators().filter(
      (operator) =>
        operator.value !== "isEmpty" &&
        operator.value !== "isNotEmpty" &&
        operator.value !== "onOrAfter" &&
        operator.value !== "onOrBefore"
    ),
    {
      label: "between",
      value: "between",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null;
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null;
        }
        return ({ value }) => {
          return (
            value !== null &&
            filterItem.value[0] <= value &&
            value <= filterItem.value[1]
          );
        };
      },
      InputComponent: InputNumberInterval,
    },
  ];

  const shiftNameFilerOperators: GridFilterOperator[] = [
    ...getGridStringOperators().filter(
      (operator) => operator.value === "contains"
    ),
  ];

  const roleFilerOperators: GridFilterOperator[] = [
    {
      label: "is",
      value: "role_is",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null;
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null;
        }
        return ({ value }) => {
          return (
            value !== null &&
            filterItem.value[0] <= value &&
            value <= filterItem.value[1]
          );
        };
      },
      InputComponent: InputRolesList,
    },
    {
      label: "isNot",
      value: "role_is_not",
      getApplyFilterFn: (filterItem: GridFilterItem) => {
        if (!Array.isArray(filterItem.value) || filterItem.value.length !== 2) {
          return null;
        }
        if (filterItem.value[0] == null || filterItem.value[1] == null) {
          return null;
        }
        return ({ value }) => {
          return (
            value !== null &&
            filterItem.value[0] <= value &&
            value <= filterItem.value[1]
          );
        };
      },
      InputComponent: InputRolesList,
    },
  ];

  function handleRowSelectionModelChange(selectedRowIds: string[]) {
    setSelectedRows(selectedRowIds);
  }

  const deleteTimesheet = React.useCallback(
    (id: GridRowId, option: any) => async () => {
      const result = await confirm("Are you sure you want to delete?", option);
      if (result) {
        dispatch<any>(trashTimesheet(id, filterData));
        setSelectionModel([]);
        return;
      }
    },
    [filterData, dispatch]
  );

  const handleFacilityForm = React.useCallback(
    (id: GridRowId) => async () => {
      setHandelaction("Change Timesheet Facility");
      dispatch<any>(getTimesheetProfile(id));
      setIsOpenFacility((isOpenFacility) => !isOpenFacility);
      //setEditRequest(true)
    },
    [dispatch]
  );

  const clockOut = React.useCallback(
    (option: any) => async () => {
      setHandelaction("ClockOut");
      dispatch<any>(getTimesheetProfile(option.row.id));
      //setEditRequest(true)
      setIsOpenClockOut((isOpenClockOut) => !isOpenClockOut);
    },
    [dispatch]
  );

  const handlePayrollChange = (timesheetId: string, payroll: string) => {
    const formData = new FormData() as unknown as UpdatePayrollFormType;
    formData.append("id", timesheetId);
    formData.append("payroll_type", payroll);
    dispatch<any>(
      updatePayrollChange(formData, filterData, timesheetId, payroll)
    );
  };

  const handleInvoiceChange = (timesheetId: string, invoice: string) => {
    const formData = new FormData() as unknown as updateInvoiceFormType;
    formData.append("id", timesheetId);
    formData.append("invoice_type", invoice);
    dispatch<any>(
      updateInvoiceChange(formData, filterData, timesheetId, invoice)
    );
  };
  const handleRegionChange = (timesheetId: string, region: string) => {
    const formData = new FormData() as unknown as updateInvoiceFormType;
    formData.append("id", timesheetId);
    formData.append("region", region);
    dispatch<any>(
      updateRegionChange(formData, filterData, timesheetId, region)
    );
  };

  const editTimesheet = React.useCallback(
    (option: any) => async () => {
      if (option.row.shift_end_date === null) {
        setIsOpenEditClockin((isOpenEditClockin) => !isOpenEditClockin);
      } else {
        setIsOpenEdit((isOpenEdit) => !isOpenEdit);
      }
      setHandelaction("Edit");
      dispatch<any>(getTimesheetProfile(option.row.id));
    },
    [dispatch]
  );

  //const columns: GridColDef<any>[] = [
  const columns: any = [
    { field: "sn", headerName: "S.N.", width: 10, filterable: false },

    // { field: "guid", headerName: "ID", width: 80, filterable: false },
    {
      field: "fullname",
      headerName: "Full Name",
      width: 200,
      renderCell: (params: any) => {
        return (
          <Link to={`/employee/profile/${params.row.userid}`}>
            {params.value!.toString()}
          </Link>
        );
      },
      filterOperators: getGridStringOperators().filter(
        (operator) =>
          operator.value !== "isNotEmpty" && operator.value !== "isEmpty"
      ),
    },
    {
      field: "user_role",
      headerName: "Payroll",
      width: 250,
      filterOperators: roleFilerOperators,
      renderCell: (params: any) => {
        return (
          <Grid item md={12} xs={12} key={`grid-select-payrollselect`}>
            <Autocomplete
              fullWidth
              // disablePortal
              id="payroll-select"
              onChange={(e, value) =>
                handlePayrollChange(params?.row?.id, value?.id ?? "")
              }
              options={payrollList ?? []}
              isOptionEqualToValue={(option, value) => {
                return option.id === value.id;
              }}
              value={
                payrollList?.filter(
                  (invoice) => invoice.id === params?.row?.payroll_type
                )?.[0] ?? null
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              clearIcon={false}
            />
          </Grid>
        );
      },
    },

    {
      field: "invoice_type",
      headerName: "Invoice",
      width: 250,
      filterOperators: roleFilerOperators,
      renderCell: (params: any) => {
        return (
          <Grid item md={12} xs={12} key={`grid-select-payrollselect`}>
            <Autocomplete
              // disablePortal
              fullWidth
              id="employeeSelect"
              onChange={(e, value) =>
                handleInvoiceChange(params?.row?.id, value?.id ?? "")
              }
              options={invoicesList ?? []}
              isOptionEqualToValue={(option, value) => {
                return option.id === value.id;
              }}
              value={
                invoicesList?.filter(
                  (invoice) => invoice.id === params?.row?.invoice_type
                )?.[0] ?? null
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              clearIcon={false}
            />
          </Grid>
        );
      },
    },

    {
      field: "region",
      headerName: "Region",
      width: 250,
      filterOperators: roleFilerOperators,
      renderCell: (params: any) => {
        return (
          <Grid item md={12} xs={12} key={`grid-select-region`}>
            <Autocomplete
              // disablePortal
              fullWidth
              id="region"
              onChange={(e, value) =>
                handleRegionChange(params?.row?.id, value?.id ?? "")
              }
              options={regionList ?? []}
              isOptionEqualToValue={(option, value) => {
                return option.id === value.id;
              }}
              value={
                regionList?.filter(
                  (invoice) => invoice.id === params?.row?.region
                )?.[0] ?? null
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  InputProps={{
                    ...params.InputProps,
                  }}
                />
              )}
              clearIcon={false}
            />
          </Grid>
        );
      },
    },
    {
      field: "facility",
      headerName: "Facility Location",
      width: 400,
      filterOperators: getGridStringOperators().filter(
        (operator) =>
          operator.value !== "isNotEmpty" && operator.value !== "isEmpty"
      ),
    },
    {
      field: "shift",
      headerName: "Shift",
      width: 120,
      filterOperators: shiftNameFilerOperators,
    },
    {
      field: "shift_start_date",
      headerName: "Start Date",
      width: 120,
      type: "date",
      valueGetter: (params: any) => new Date(params.value),
      filterOperators: dateFilerOperators,
    },
    {
      field: "shift_start_time",
      headerName: "Start Time",
      width: 100,
      filterable: false,
    },
    {
      field: "shift_end_date",
      headerName: "End Date",
      width: 100,
      type: "date",
      valueGetter: (params: any) => {
        if (params.value) {
          return new Date(params.value);
        } else {
          return "";
        }
      },

      filterOperators: dateFilerOperators,
    },
    {
      field: "shift_end_time",
      headerName: "End Time ",
      width: 100,
      filterable: false,
    },
    {
      field: "shift_break",
      headerName: "Break Time",
      width: 100,
      filterable: false,
    },
    {
      field: "total_time",
      headerName: "Total Time",
      width: 100,
      filterable: false,
    },
    {
      field: "holiday_name",
      headerName: "Is Holiday",
      width: 100,
      filterable: false,
    },

    {
      field: "system_start_date",
      headerName: "Acutal Clock In",
      width: 160,
      filterable: false,
      valueGetter: (params: any) => {
        if (params.value) {
          return moment(params.value).format(`DD/MM/YYYY HH:mm`);
        } else {
          return "-";
        }
      },
    },
    {
      field: "system_end_date",
      headerName: "Actual Clock Out",
      width: 160,
      filterable: false,

      valueGetter: (params: any) => {
        if (params.value) {
          return moment(params.value).format(`DD/MM/YYYY HH:mm`);
        } else {
          return "-";
        }
      },
    },
    {
      field: "shift_start_location",
      headerName: "Start Location",
      width: 100,
      filterable: false,
    },
    {
      field: "shift_end_location",
      headerName: "End  Location",
      width: 100,
      filterable: false,
    },
    {
      field: "shift_comments",
      headerName: "Comments",
      width: 200,
      filterable: false,
      renderCell: renderCellExpand,
    },
    {
      field: "authorized_wardnamnager",
      headerName: "Authorized Ward Manager",
      width: 100,
      filterable: false,
      renderCell: renderCellExpand,
    },
    {
      field: "remarks",
      headerName: "Remarks",
      width: 100,
      filterable: false,
      renderCell: renderCellExpand,
    },
    {
      field: "actions",
      type: "actions",
      minWidth: 20,
      flex: 0.1,
      getActions: (params: any) => [
        <GridActionsCellItem
          icon={<EditIcon />}
          label="Change Facility"
          showInMenu
          onClick={handleFacilityForm(params.id)}
          key="action-1"
        />,
        <GridActionsCellItem
          icon={<AccessTimeIcon />}
          label="ClockOut"
          showInMenu
          onClick={clockOut(params)}
          disabled={params.row.shift_end_date !== null}
          key="action-2"
        />,
        <GridActionsCellItem
          icon={<HourglassDisabledIcon />}
          label="Edit Time"
          showInMenu
          onClick={editTimesheet(params)}
          key="action-3"
        />,
        <GridActionsCellItem
          icon={<DeleteIcon />}
          label="Trash"
          showInMenu
          onClick={deleteTimesheet(params.id, customOptions)}
          key="action-4"
        />,
      ],
    },
  ];

  // const label = { inputProps: { "aria-label": "Switch people" } };
  let rows =
    Array.isArray(timesheets) && timesheets?.length >= 0
      ? timesheets.map((timesheet: ITimesheet, index: number) => {
          let _id = current === 1 ? 1 : 10 * (current - 1) + 1;
          return {
            id: timesheet.id,
            sn: index + _id,
            // guid: timesheet.employee.guid,
            fullname: `${timesheet.employee.fullname}`,
            facility: timesheet.facility_location.facility_tree,
            //facility_location:timesheet.facility_location,
            shift_start_date: timesheet.shift_start_date,
            shift_start_time: timesheet.shift_start_time,
            shift_end_time: timesheet.shift_end_time
              ? timesheet.shift_end_time
              : null,
            shift_end_date: timesheet.shift_end_date
              ? timesheet.shift_end_date
              : null,
            shift_break: timesheet.break_time ? timesheet.break_time : "-",
            shift: timesheet.shift,
            total_time: timesheet.total_hours ? timesheet.total_hours : "-",
            authorized_wardnamnager: timesheet.authorized_wardnamnager
              ? timesheet.authorized_wardnamnager
              : "-",
            shift_comments: timesheet.shift_comments
              ? timesheet.shift_comments
              : "-",

            user_role: timesheet.user_role ? timesheet.user_role : "-",
            invoice_type: timesheet?.invoice_type,

            holiday_name: timesheet.is_holiday ? "Yes" : "No",
            remarks: timesheet.is_holiday ? timesheet.holiday_name : "-",
            userid: timesheet.employee.id,
            role: timesheet.employee.user_role,
            shift_start_location: timesheet.shift_start_location,
            shift_end_location: timesheet.shift_end_location,
            system_start_date: timesheet.system_start_date,
            system_end_date: timesheet.system_end_date,
            payroll_type: timesheet.payroll_type,
            region: timesheet.region,
          };
        })
      : [];

  /* const handleChange = (event: React.ChangeEvent<HTMLInputElement>, clickedRow: any) => {
    const formData = new FormData();
    const data: any = event.target.checked;
    formData.append('is_active', data);
    dispatch<any>(updateTimesheetStatus(formData, clickedRow));
  }; */

  const csvHeaders = [
    { label: "Payroll", key: "role" },
    { label: "Full Name", key: "fullname" },
    { label: "Authorized wardmanager", key: "authorized_wardnamnager" },
    { label: "Break time", key: "break_time" },
    {
      label: `Facility`,
      key: "facility_location.facility_tree",
    },

    { label: "guid", key: "guid" },
    { label: "holiday_name", key: "holiday_name" },
    { label: "id", key: "id" },
    { label: "is_holiday", key: "is_holiday" },
    { label: "shift", key: "shift" },
    { label: "shift_comments", key: "shift_comments" },
    { label: "shift_end_date", key: "shift_end_date" },
    { label: "shift_end_location", key: "shift_end_location" },
    { label: "shift_end_time", key: "shift_end_time" },
    { label: "shift_start_date", key: "shift_start_date" },
    { label: "shift_start_location", key: "shift_start_location" },
    { label: "shift_start_time", key: "shift_start_time" },
    { label: "subsidiary", key: "subsidiary" },
    { label: "system_end_date", key: "system_end_date" },
    { label: "system_start_date", key: "system_start_date" },
    { label: "total_hours", key: "total_hours" },
  ];

  useEffect(() => {
    if (csvData.length) {
      csvDownloadBtn.current.link.click();
    }
  }, [csvData]);

  // const getCSVData = (e: any, done: (arg0: boolean) => void) => {
  //   axiosInstance
  //     .get("/timesheet/csv?" + filters)
  //     .then((res) => {
  //       setCsvData(res.data);
  //       done(true);
  //     })
  //     .catch((err) => {
  //       console.log("Server Error. Please try later.");
  //       done(false);
  //     });
  // };

  const handleClickOpen = () => {
    setIsOpen(!isOpen);
    setHandelaction(`Add timesheet`);
  };

  useEffect(() => {
    dispatch<any>(loadTimesheet(filterData));
    dispatch<any>(loadInvoices());
    dispatch<any>(loadPayrolls());
    dispatch<any>(loadRegions());
  }, [stateFlag, dispatch, filterData]);

  const handleCloseTimesheetEditForm = useCallback(
    () => setIsOpenEdit(false),
    []
  );

  const handleCloseTimesheetClockInForm = useCallback(() => {
    setIsOpenEditClockin(false);
  }, []);

  const handleCloseFacilityForm = useCallback(
    () => setIsOpenFacility(false),
    []
  );

  const handleCloseClockoutForm = useCallback(() => {
    setIsOpenClockOut(false);
  }, []);

  const handleCloseTimesheetForm = useCallback(() => {
    setIsOpen(false);
  }, []);
  function handleBulkDelete() {
    const formData = { id: selectedRows };
    dispatch<any>(bulkTimesheetDelete(formData));
  }

  const handleOpenInvoiceClick = () => {
    setOpenInvoice(true);
  };

  const handleInvoiceClose = () => {
    setOpenInvoice(false);
    dispatch({ type: TIMESHEET_SAVE_REQUEST });
  };
  // function handleConfirmAddTimesheet() {}
  // function handleCloseConfirmTimesheetDialog() {}

  const handleRequestPayroll = () => {
    setIsFortnightRequest(!isFortnightRequest);
  };
  const handleCreatePayroll = () => {
    setIsPayrollCreateClick(true);
    dispatch(createPayroll());
  };
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <WithPermission
          roleReqiured={["ADMIN", "EMPLOYEE", "STAFF", "USER"]}
          message="Access Denied"
        >
          <Item>
            {/* <CustomGridHeader
              title={`timesheet`}
              handleAddClick={handleClickOpen}
              handleBulkDelete={handleBulkDelete}
              disabledTrashState={selectedRows?.length <= 0}
            /> */}
            <Stack
              direction="row"
              alignItems="center"
              justifyContent="space-between"
              mb={2}
            >
              <Typography variant="h6" fontSize={"1.67rem"} gutterBottom m={1}>
                {`Timesheet`}
              </Typography>

              <Box
                display="flex"
                justifyContent="flex-start"
                alignItems="flex-start"
              >
                <Button
                  variant="contained"
                  onClick={() => handleRequestPayroll()}
                  startIcon={<DescriptionIcon />}
                  sx={{ mr: 1 }}
                  color={isFortnightRequest ? "error" : "primary"}
                >
                  {isFortnightRequest
                    ? `Cancel payroll view`
                    : `Request payroll`}
                </Button>

                <Box sx={{ mr: 1, position: "relative" }}>
                  <Button
                    type="submit"
                    form="companyform"
                    variant="contained"
                    color="primary"
                    startIcon={<ReceiptIcon />}
                    disabled={
                      !isFortnightRequest || (loading && isPayrollCreateClick)
                    }
                    onClick={() => handleCreatePayroll()}
                  >
                    Create Payroll
                  </Button>
                  {loading && isPayrollCreateClick && (
                    <CircularProgress
                      size={24}
                      sx={{
                        // color: green[500],
                        position: "absolute",
                        top: "50%",
                        left: "50%",
                        marginTop: "-12px",
                        marginLeft: "-12px",
                      }}
                    />
                  )}
                </Box>
                {/* <Button
                  variant="contained"
                  onClick={() => handleCreatePayroll()}
                  startIcon={<ReceiptIcon />}
                  sx={{ mr: 1 }}
                  disabled={!isFortnightRequest}

                >
                  {`Create Payroll`}
                </Button> */}
                <Button
                  variant="contained"
                  onClick={() => handleOpenInvoiceClick()}
                  startIcon={<AddIcon />}
                  sx={{ mr: 1 }}
                >
                  {`Invoice`}
                </Button>
                <Button
                  variant="contained"
                  onClick={() => handleClickOpen()}
                  startIcon={<AddIcon />}
                  sx={{ mr: 1 }}
                  disabled={isFortnightRequest}
                >
                  {`Timesheet`}
                </Button>
                <Button
                  variant="contained"
                  color="error"
                  onClick={handleBulkDelete}
                  // onClick={() => handleTrash(customOptions)}
                  disabled={selectedRows?.length <= 0}
                  startIcon={<DeleteIcon />}
                >
                  Trash
                </Button>
              </Box>
            </Stack>
            <Box sx={{ height: 700, width: "100%" }}>
              {rows ? (
                <CustomDataGridPro
                  totalRows={total}
                  loading={loading}
                  columns={columns}
                  rows={rows}
                  setFilterData={setFilterrData}
                  filterData={filterData}
                  csvHeaders={csvHeaders}
                  exportCSVUrl="/timesheet/csv"
                  defaultCSVExport={false}
                  pageLimit={pageSize}
                  setPageLimit={setPageSize}
                  setCurrentPage={setPage}
                  currentPage={page}
                  handleRowSelectionModelChange={handleRowSelectionModelChange}
                  csvFilename={`Timesheet`}
                />
              ) : (
                <TableSkeleton />
              )}
            </Box>
          </Item>
        </WithPermission>
      </Grid>
      {/* <ConfirmTimesheetDialog
        isOpen={isConfirmAddTimesheetDialogOpen}
        handleCloseDialog={handleCloseConfirmTimesheetDialog}
        handleConfirmAddTimesheet={handleConfirmAddTimesheet}
      /> */}

      <TimesheetInvoice
        isDialogOpened={isOpenInvoice}
        handleCloseDialog={handleInvoiceClose}
        filterData={filterData}
        title={"Invoice"}
      />
      <TimesheetForm
        titleName={`Timesheet`}
        isDialogOpened={isOpen}
        handleCloseDialog={handleCloseTimesheetForm}
        action={handelaction}
        filterData={filterData}
      />
      <ClockoutForm
        // titleName="timesheet"
        isDialogOpened={isOpenClockOut}
        handleCloseDialog={handleCloseClockoutForm}
        action={handelaction}
        filterData={filterData}
      />

      <FacilityForm
        // titleName={menus["timesheet"] ?? ""}
        isDialogOpened={isOpenFacility}
        handleCloseDialog={handleCloseFacilityForm}
        action={handelaction}
        filterData={filterData}
      />

      <TimesheetEditForm
        // titleName={menus["timesheet"] ?? ""}
        isDialogOpened={isOpenEdit}
        handleCloseDialog={handleCloseTimesheetEditForm}
        action={handelaction}
        filterData={filterData}
      />
      <TimesheetEditClockInForm
        // titleName={menus["timesheet"] ?? ""}
        isDialogOpened={isOpenEditClockin}
        handleCloseDialog={handleCloseTimesheetClockInForm}
        action={handelaction}
        filterData={filterData}
      />
    </Grid>
  );
}
